import React from "react";

const variants = {
  dark: {
    frame: "rgba(240, 222, 170, 0.18)",
    fill: "#EAF0FF",
    accent: "#D2B166",
    accentSoft: "rgba(210, 177, 102, 0.22)",
  },
  light: {
    frame: "rgba(11, 18, 32, 0.12)",
    fill: "#0B1220",
    accent: "#B68C38",
    accentSoft: "rgba(182, 140, 56, 0.14)",
  },
  mono: {
    frame: "rgba(255,255,255,0.18)",
    fill: "currentColor",
    accent: "currentColor",
    accentSoft: "rgba(255,255,255,0.12)",
  },
};

export const BrandMark = ({
  className = "",
  size = 30,
  title = "VenuLoQ Team Portal",
  variant = "dark",
}) => {
  const palette = variants[variant] || variants.dark;

  return (
    <svg
      aria-labelledby="venuloq-brand-title"
      className={className}
      height={size}
      role="img"
      viewBox="0 0 64 64"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="venuloq-brand-title">{title}</title>
      <rect
        fill={palette.accentSoft}
        height="54"
        rx="16"
        stroke={palette.frame}
        strokeWidth="1.2"
        width="54"
        x="5"
        y="5"
      />
      <path
        d="M16 15.5h23.6l8.9 8.7V49H16z"
        fill="none"
        opacity="0.48"
        stroke={palette.frame}
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
      <path
        d="M39.6 15.5v8.8H48"
        fill="none"
        opacity="0.55"
        stroke={palette.frame}
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
      <path
        d="M22 21.5 31.4 43l10.3-21.5"
        fill="none"
        stroke={palette.fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.6"
      />
      <circle cx="43.5" cy="42.5" fill={palette.accent} r="3.6" />
    </svg>
  );
};
